import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Pagination, Stack } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { confirmAlert } from "react-confirm-alert";
import { ApiError } from "../../Api/ApiError";
import { delChargeCategory, getChargeCategoryList } from "../../Api/Store";
import { ChargeCategory } from "../../Objects/ChargeCategory";
import { ChargeCategoryItem } from "../molecules/ChargeCategoryItem";
import { ChargeCategoryEditDialog } from "./ChargeCategoryEditDialog";

export interface ChargeCategoryDialogProps {
    open: boolean
    onClose: () => void
}
export function ChargeCategoryDialog({
    open,
    onClose,
}: ChargeCategoryDialogProps): React.ReactElement {
    const { enqueueSnackbar } = useSnackbar()
    const [page, setPage] = React.useState<number>(1)
    const [num, setNum] = React.useState<number>(3)
    const [chargeCategoryList, setChargeCategoryList] = React.useState<ChargeCategory[]>([])
    const [rows, setRows] = React.useState<number>(0)

    const [editChargeCategory, setEditChargeCategory] = React.useState<ChargeCategory>()

    const fetchData = React.useCallback(() => {
        getChargeCategoryList({
            offset: (page - 1) * num,
            num: num,
        }).then(result => {
            setChargeCategoryList(result.chargeCategoryList)
            setRows(result.rows)
        }).catch((e: any) => {
            if (e.__CANCEL__) {
                console.info("canceled")
            } else if (e instanceof ApiError) {
                enqueueSnackbar(e.message, { variant: "error" })
            } else if (e instanceof Error) {
                enqueueSnackbar(e.message, { variant: "error" })
            } else {
                enqueueSnackbar("通信に失敗しました", { variant: "error" })
            }
        })
    }, [enqueueSnackbar, page, num])

    const doDelete = React.useCallback((chargeCategory: ChargeCategory) => {
        confirmAlert({
            title: "料金カテゴリー削除",
            message: "料金カテゴリーを抹消をします。この操作は取り消せません。よろしいですか？",
            buttons: [
                {
                    label: "削除実行",
                    onClick: () => {
                        delChargeCategory({
                            categoryCharge: chargeCategory
                        }).then(() => {
                            enqueueSnackbar("データを削除しました", { variant: "success" })
                            fetchData()
                        }).catch((e: any) => {
                            if (e.__CANCEL__) {
                                console.info("canceled")
                            } else if (e instanceof ApiError) {
                                enqueueSnackbar(e.message, { variant: "error" })
                            } else if (e instanceof Error) {
                                enqueueSnackbar(e.message, { variant: "error" })
                            } else {
                                enqueueSnackbar("通信に失敗しました", { variant: "error" })
                            }
                        })
                    }
                }, {
                    label: "キャンセル",
                    onClick: () => { }
                }
            ]
        })
    }, [enqueueSnackbar, fetchData])

    const onEditDialogClose = React.useCallback(() => {
        setEditChargeCategory(undefined)
        fetchData()
    }, [fetchData])

    React.useEffect(() => {
        if (open) {
            fetchData()
        }
    }, [open, fetchData])

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth
            >
                <DialogTitle>料金カテゴリー設定</DialogTitle>
                <DialogContent>
                    <Box
                        mb={2}
                    >
                        <Button
                            variant="outlined"
                            onClick={() => {
                                setEditChargeCategory({})
                            }}
                        >新規登録</Button>
                    </Box>
                    <Stack
                        spacing={2}
                    >
                        <Pagination
                            count={Math.ceil(rows / num)}
                            page={page}
                            onChange={(e, page) => {
                                setPage(page)
                            }}
                        />
                        {chargeCategoryList.map(chargeCategory => <ChargeCategoryItem
                            key={chargeCategory.chrcate_id}
                            chargeCategory={chargeCategory}
                            onEdit={(chargeCategory) => {
                                setEditChargeCategory(chargeCategory)
                            }}
                            onDelete={doDelete}
                        />)}
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        onClick={onClose}
                    >閉じる</Button>
                </DialogActions>
            </Dialog>
            <ChargeCategoryEditDialog
                chargeCategory={editChargeCategory}
                onClose={onEditDialogClose}
                dialogProps={{
                    fullWidth: true,
                    hideBackdrop: true,
                    PaperProps: {
                        sx: {
                            transform: "translateX(16px)",
                        }
                    }
                }}
            />
        </>
    )
}